module.exports = __webpack_public_path__ + "img/logo.9cdd2316.png";